<template>
  <div>
    <v-card>
      <v-card-title>
        <v-layout row wrap align-center>
          <v-flex sm6 xs12 d-flex>
            <v-toolbar flat color="white">
              <v-toolbar-title>Base Distance Table</v-toolbar-title>
              <v-divider class="mx-2" inset vertical></v-divider>
              <create-base-distance @onCreate="createBaseDistance($event)" />
            </v-toolbar>
          </v-flex>
        </v-layout>
      </v-card-title>
      <base-distance-table
        :isLoading="isLoading"
        :headers="headers"
        :baseDistanceList="baseDistanceList"
      />
    </v-card>
  </div>
</template>

<script>
import BaseDistanceTable from "@/components/back-office/BaseDistance/BaseDistanceTable.vue";
import CreateBaseDistance from "@/components/back-office/BaseDistance/CreateBaseDistance.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      isLoading: false,
      headers: [
        {
          text: "#",
          align: "left",
          sortable: false,
        },
        { text: "Time start", align: "center", sortable: false },
        { text: "Time end", align: "center", sortable: false },
      ],
    };
  },
  computed: {
    ...mapState({
      baseDistanceList: (state) => state.distances.baseDistanceList,
    }),
  },
  components: {
    "base-distance-table": BaseDistanceTable,
    "create-base-distance": CreateBaseDistance,
  },
  methods: {
    async createBaseDistance(e) {
      let payload = {
        distance_text: [],
      };
      payload.distance_text = e.form.distance_text;
      let result = await this.$store.dispatch(
        "distances/createBaseDistanceOld",
        payload
      );
      if (result == false) return;
      e.done();
    },
  },
  async created() {
    this.isLoading = true;
    await this.$store.dispatch("distances/getBaseDistanceList");
    this.isLoading = false;
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Food delivery",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/food/promotion",
      },
      {
        text: "Set Base Distance",
        disabled: true,
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style lang="scss" scoped></style>
